export default function SvgArrowLeft(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg {...props} viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.88331 8.99133L19.4307 8.99133" stroke="white" strokeWidth="2" strokeMiterlimit="10" />
            <path d="M7.76074 16.9828L2.1609 11.0508C1.0696 9.89472 1.06961 8.08808 2.16091 6.93204L7.76074 1.00001"
                  stroke="white" strokeWidth="2" strokeMiterlimit="10" />
        </svg>
    );
}
